import { dashboardSalesReportListOptions } from '@crm/api'
import { Funnel } from '@crm/components'
import { getColor, getFunnelColor } from '@crm/components/Charts/utils'
import { useStyles } from '@crm/features/dashboard/styles'
import { useAppNavigate } from '@crm/hooks/useAppNavigate'
import { paths } from '@crm/routes'
import { Text } from '@shared/components'
import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { useQuery } from '@tanstack/react-query'
import { Button, Card, Col, Flex, List, Row, Space, theme } from 'antd'
import cn from 'classnames'
import { useCallback, useMemo } from 'react'

export const SalesFunnel = () => {
  const { t } = useLocales()
  const { token } = theme.useToken()
  const { styles } = useStyles()
  const navigate = useAppNavigate()

  const { params } = useQueryUpdate()

  const { data = [], isLoading } = useQuery(
    dashboardSalesReportListOptions({
      query: params
    })
  )

  const chartData = useMemo(
    () =>
      data?.map((item, i: number) => ({
        text: item?.name,
        value: item?.count,
        color: getColor(i)
      })),
    [data]
  )

  const hasChart = chartData.length > 0

  const onViewAll = useCallback(() => {
    const qs = params?.user ? `?owner=${params.user}` : ''
    navigate(`${paths.opportunities}${qs}`)
  }, [navigate, params?.user])

  return (
    <Card
      className={cn(
        styles.card,
        styles.dashboardCharts,
        styles.flexGrowDashboardCharts
      )}
      variant="borderless"
      loading={isLoading}
      title={t('menu.sales_funnel')}
      actions={[
        <Flex key="sales-funnel-actions" justify="space-between" align="center">
          <Space size="small">
            {`${t('reports.total')}:`}
            {data.length}
          </Space>

          <Button onClick={onViewAll} type="primary" loading={isLoading}>
            {t('reports.view_all')}
          </Button>
        </Flex>
      ]}
    >
      <Row gutter={[16, 16]} className="h-full">
        {hasChart && (
          <Col xs={24} sm={24} md={24} lg={12}>
            <Funnel dataSource={chartData} />
          </Col>
        )}

        <Col xs={24} sm={24} md={24} lg={hasChart ? 12 : 24}>
          <List
            rowKey={(item) => `${item.text}-${item.value}`}
            loading={isLoading}
            locale={{ emptyText: t('common.noData') }}
            dataSource={chartData}
            renderItem={({ text, value }, index) => (
              <List.Item className={styles.listItem}>
                <Flex className="w-full" align="center" justify="space-between">
                  <List.Item.Meta
                    title={text}
                    avatar={
                      <div
                        className={styles.listItemAvatar}
                        style={{ background: getFunnelColor(token, index) }}
                      />
                    }
                  />
                  <Text>{value}</Text>
                </Flex>
              </List.Item>
            )}
          />
        </Col>
      </Row>
    </Card>
  )
}
